module.exports = __webpack_public_path__ + "img/solution_round_two.10524e94.png";